// Google Identity Services Configuration and Utilities

// Initialize Google Identity Services
export const initializeGoogleIdentity = (clientId, callback) => {
  if (typeof window === 'undefined' || !window.google?.accounts?.id) {
    throw new Error('Google Identity Services not loaded');
  }

  if (!clientId) {
    throw new Error('Google client ID is required');
  }

  window.google.accounts.id.initialize({
    client_id: clientId,
    callback,
    auto_select: false,
    cancel_on_tap_outside: true,
  });
};

// Render the Google Sign-In button
export const renderGoogleSignInButton = (elementId, options = {}) => {
  if (typeof window !== 'undefined' && window.google) {
    const defaultOptions = {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'rectangular',
      logo_alignment: 'left',
      width: 300,
      ...options
    };

    window.google.accounts.id.renderButton(
      document.getElementById(elementId),
      defaultOptions
    );
  } else {
  }
};

// Render the Google One Tap prompt
export const renderGoogleOneTap = (options = {}) => {
  if (typeof window !== 'undefined' && window.google) {
    const defaultOptions = {
      context: 'signin',
      ...options
    };

    window.google.accounts.id.prompt(defaultOptions);
  } else {
  }
};

// Cancel the Google One Tap prompt
export const cancelGoogleOneTap = () => {
  if (typeof window !== 'undefined' && window.google) {
    window.google.accounts.id.cancel();
  }
};

// Get the Google Identity Services instance
export const getGoogleIdentityInstance = () => {
  if (typeof window !== 'undefined' && window.google) {
    return window.google.accounts.id;
  }
  return null;
};

// Check if Google Identity Services is loaded
export const isGoogleIdentityLoaded = () => {
  return typeof window !== 'undefined' && 
         window.google && 
         window.google.accounts && 
         window.google.accounts.id;
};

// Wait for Google Identity Services to load
export const waitForGoogleIdentity = () => {
  return new Promise((resolve) => {
    if (isGoogleIdentityLoaded()) {
      resolve();
    } else {
      const checkInterval = setInterval(() => {
        if (isGoogleIdentityLoaded()) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);

      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        resolve();
      }, 10000);
    }
  });
};

// Decode the JWT token from Google
export const decodeGoogleToken = (credential) => {
  try {
    // The credential is a JWT token that can be decoded
    const payload = JSON.parse(atob(credential.split('.')[1]));
    return {
      sub: payload.sub, // Google user ID
      email: payload.email,
      name: payload.name,
      picture: payload.picture,
      given_name: payload.given_name,
      family_name: payload.family_name,
      email_verified: payload.email_verified,
      iat: payload.iat,
      exp: payload.exp
    };
  } catch (error) {
    return null;
  }
};

// Default configuration
export const GOOGLE_IDENTITY_CONFIG = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,

  promptParentId: 'google-signin-container'
}; 